import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { TranslateService } from "@ngx-translate/core";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { DxDataGridComponent, DxAccordionComponent, DxSelectBoxComponent } from "devextreme-angular";
import { UserService } from "src/app/services/user.service";
import { MapInformationService } from '../../../services/map-information.service'


@Component({
  selector: "app-navbar-cubeWork",
  templateUrl: "./navbar-cubeWork.component.html",
  styleUrls: ["./navbar-cubeWork.component.scss"],
})
export class NavBarCubeWorkComponent implements OnInit {
  @ViewChild(DxSelectBoxComponent, { static: false })  SelectSites: DxSelectBoxComponent;
  isActive: boolean = false;
  cubeWork: boolean = true
  userName: any
  popupChangePass: boolean = false
  password: any;

  @Input() animationPopup: any;

  popupVisible = false;

  modelChangePassword = {
    pass: '',
    confirmPass: ''
  };



  constructor(
    private datePipe: DatePipe,
    private toast: ToastService,
    private translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    public userService: UserService,
    public activatedRouter: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    public MapInformationService: MapInformationService
  ) {
    
    this.userName = localStorage.getItem("userName");

  }

  ngOnInit() {}

  showPopup() {
    this.popupVisible = true;
  }

  onPopupHiding() {
    this.popupVisible = false;
  }

  NavCubeWorks(to){
    console.log(to)
    this.router.navigate([`/${to}`])
    this.isActive = !this.isActive;
  }

  ExpandCubeBox(){
    window.open(document.URL)
  }

  logOut() {
    let settings = localStorage.getItem('settings');
    sessionStorage.clear();
    localStorage.clear();
    this.userService.currentUserName.next('');
    this.router.navigateByUrl('/login');
    localStorage.setItem('settings', settings)
  }

  changePass() {
    this.userService.changePasswordCW(this.modelChangePassword.pass).subscribe(result => {
      if (result.response == 0) {
        this.toast.success('Password was changed.');
      }
    });
  }

  BackCubeEdge(){
    this.router.navigateByUrl('/home');
  }
}
